<template>
  <div class="records">
    <BaseText1 text="stats &amp; records"/>
    <div class="rankings-container">
      <BaseText5 text="rankings"/>
      <div class="rankings">
        <div :style="{ backgroundColor: opponentBackgroundColour, color: opponentTextColour }" class="letter">{{ opponentRank }}</div>
        <div class="info">
          <img class="flag" :src="opponentFlag">
          <BaseText1 :text="opponentWinLoss"/>
        </div>
        <img class="opponent-image" :src="opponentImage">
      </div>
    </div>
    <div class="stat-group">
      <div class="stat-item">
        <BaseText5 text="Total fights"/>
        <BaseText3 class="total-fights" :text="opponentTotalFights"/>
      </div>
      <div class="stat-item">
        <DonutChart label="Wins" :value="opponentWins.toString()" :ratio="parseInt(opponentWins) / parseInt(opponentTotalFights)"/>
      </div>
    </div>
    <div class="stat-group">
      <div class="stat-item">
        <BaseText5 text="Losses"/>
        <BaseText3 :text="opponentLosses"/>
      </div>
      <div class="stat-item">
        <BaseText5 text="Reach"/>
        <BaseText3 :text="opponentReach"/>
      </div>
      <div class="stat-item">
        <BaseText5 text="MMA Record"/>
        <BaseText3 :text="opponentMmaRecord"/>
      </div>
      <div class="stat-item">
        <BaseText5 text="Knockouts"/>
        <BaseText3 :text="opponentKnockouts"/>
      </div>
    </div>
  </div>
</template>

<script>
import BaseText1 from '@/components/BaseText1/BaseText1'
import BaseText3 from '@/components/BaseText3/BaseText3'
import BaseText5 from '@/components/BaseText5/BaseText5'
import DonutChart from '../../../../components/DonutChart/DonutChart'
export default {
  components: {
    BaseText1,
    BaseText3,
    BaseText5,
    DonutChart
  },
  props: {
    opponentFlag: {
      type: String,
      required: true
    },
    opponentImage: {
      type: String,
      required: true
    },
    opponentRank: {
      type: String,
      required: true
    },
    opponentWinLoss: {
      type: String,
      required: true
    },
    opponentTotalFights: {
      type: String,
      required: true
    },
    opponentWins: {
      type: String,
      required: true
    },
    opponentLosses: {
      type: String,
      required: true
    },
    opponentReach: {
      type: String,
      required: true
    },
    opponentMmaRecord: {
      type: String,
      required: true
    },
    opponentKnockouts: {
      type: String,
      required: true
    },
    opponentBackgroundColour: {
      type: String,
      required: true
    },
    opponentTextColour: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.records {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .donut-chart {
    width: 3rem;
  }
  .total-fights {
    font-size: 7rem;
  }
}
.rankings-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  text-align: left;
  margin: 2rem 0 0 0;
  .rankings {
    position: relative;
    display: flex;
    width: 100%;
    height: 3.5rem;
  }
  .letter {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    width: 4.5rem;
    height: 100%;
    flex-shrink: 0;
  }
  .info {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: var(--spacing-3) var(--spacing-4);
    background: var(--color-gray-2);
    font-size: 1rem;
    text-transform: uppercase;
    width: 100%;
    overflow: hidden;
  }
  .flag {
    height: 100%;
    margin-right: 1.6rem;
  }
  .opponent-image {
    position: absolute;
    width: 180px;
    bottom: 0;
    left: 5%;
  }
}
.stat-group {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  white-space: nowrap;
  margin: 2rem 0 0 0;
  .stat-item:not(:last-child) {
    margin-right: 2rem
  }
}
.stat-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}
</style>
